var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageEdit',{on:{"init":_vm.handleInit,"submit":_vm.handleSubmit}},[_c('PaymentTypeList',{attrs:{"userData":_vm.userData,"paymentTypeList":_vm.paymentTypeList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }